module.exports = __webpack_public_path__ + "static/media/guincho.5e6298fa.svg";